import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './blog.css';
import Header from '../../components/Navbar/Navbar.js';
import Footer from '../../components/Footer/Footer.js';
import { images } from '../../config/imagePaths';

const blogPosts = [
    {
    date: '14/05/2025',
    title: 'AOK Communications Founder Wins Laois Business Award',
    description: 'We’re thrilled to share that Alison O’Kelly, founder of AOK Communications, has been named the Laois Rising Star at the 2025 Laois Business Awards!',
    image: images.home.homeImage,
    link: '/rising-star'
  },
  {
    date: '24/09/2024',
    title: 'Digital Marketing: 5 signs You’re Ready to ask for Help',
    description: 'If you’ve ever found yourself wondering when it’s time to ask for help with your digital marketing and social media, this post is for you.',
    image: images.blog.fiveSigns,
    link: '/marketing-5-signs'
  },
  {
    date: '12/08/2024',
    title: 'How Your Business Can Benefit from Ireland’s Biggest Music Festival',
    description: 'Electric Picnic is right around the corner! This is how your business can benefit.',
    image: images.blog.musicFestival,
    link: '/festival'
  },
  {
    date: '01/08/2024',
    title: 'How Digital Marketing Agencies can Boost your Productivity',
    description: 'Ever wonder what it is we actually do? You’re about to find out!',
    image: images.blog.productivity,
    link: '/boost-productivity'
  },
  {
    date: '15/07/2024',
    title: 'One Year of Barbie: The Lessons you can Learn from the Sensation’s Marketing Campaigns',
    description: 'As we approach the one-year anniversary of this iconic movie, it’s the perfect time to reflect on what the exceptionally talented marketing team did right!',
    image: images.blog.barbie,
    link: '/barbie'
  },
  {
    date: '28/06/2024',
    title: 'Meta AI: Here’s What You Need to Know About Embracing the Future of Social Media',
    description: 'Once you take the time to understand what is happening and ask the right questions, AI incorporation can be a really exciting experience.',
    image: images.blog.metaAi,
    link: '/meta-ai'
  },
  {
    date: '02/04/2024',
    title: 'Why Improving your Public Speaking Skills is so Crucial in Todays world',
    description: 'Unlock the key to communicative success!',
    image: images.blog.presentation,
    link: '/public-speaking-skills'
  },
  {
    date: '26/03/2024',
    title: 'Hashtags: The Small but Mighty Tools Elevating your Social Media',
    description: 'When used correctly, hashtags can bring a post form 0 to 100!',
    image: images.blog.hashtags,
    link: '/hashtags'
  },
  {
    date: '09/03/2024',
    title: 'The Art of Networking: Enterprise Week 2024',
    description: 'Some of the key takeaways from the week!',
    image: images.blog.networking,
    link: '/networking-enterprise'
  },
  {
    date: '01/03/2024',
    title: 'The Path to Professional Success: LinkedIn',
    description: 'Whether you\'re an individual looking to advance your career or a business aiming to expand its reach, LinkedIn is the way forward.',
    image: images.blog.linkedin,
    link: '/linked-in'
  },
  {
    date: '16/02/2024',
    title: 'The Power of the Spoken Word in Digital Marketing',
    description: 'Why we decided to combine public speaking and digital marketing into our strategy.',
    image: images.home.publicSpeaking,
    link: '/power-spoken-word'
  },
  {
    date: '09/02/2024',
    title: 'Navigating the Digital Frontier: The Power of Digital Marketing for Business Growth',
    description: 'The crucial strategy that has proven to be a game-changer for businesses - Digital Marketing.',
    image: images.blog.digitalFrontier,
    link: '/digital-frontier'
  },
];

function Blogs() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;
      const buffer = 10;
      if (currentScroll > 30 + buffer && !scrolled) {
        setScrolled(true);
      } else if (currentScroll < 20 - buffer && scrolled) {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrolled]);

  const closeMenu = () => {
    setMenuOpen(false);
    setAboutOpen(false);
    setServicesOpen(false);
  };

  return (
    <div className="blog-page">
      <Header />

      <section className="blog-container">
        <h2>Our Blog</h2>
        <div className="blog-grid">
          {blogPosts.map((post, i) =>
            post.link ? (
              <Link to={post.link} key={i} className="blog-card-link" onClick={closeMenu}>
                <div className="blog-card">
                  <img src={post.image} alt="blog thumbnail" />
                  <div className="blog-content">
                    <p className="blog-date">{post.date}</p>
                    <h3>{post.title}</h3>
                    <p>{post.description}</p>
                  </div>
                </div>
              </Link>
            ) : (
              <div key={i} className="blog-card">
                <img src={post.image} alt="blog thumbnail" />
                <div className="blog-content">
                  <p className="blog-date">{post.date}</p>
                  <h3>{post.title}</h3>
                  <p>{post.description}</p>
                </div>
              </div>
            )
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Blogs;
